const logindex = r => require.ensure([], () => r(require('@/page/log/logindex')), 'logindex');
const logindexkeepalive = r => require.ensure([], () => r(require('@/page/log/logindexkeepalive')), 'logindexkeepalive');
const logRecord = r => require.ensure([], () => r(require('@/page/log/logRecord')), 'logRecord');

const logindexRouter = {
  path: '',
  component: logindexkeepalive,
  meta: {
    icon: 'propertyAreaMge',
    right: [],
    isShowMenu: true,
    keepAlive:false
  },
  name: '定时任务管理',
  children: [{
    path: '/logindex',
    component: logindex,
    name: '定时任务管理',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:false,
    },
  },
    {
      path: '/logRecord',
      component:logRecord,
      name: '执行记录',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:false,
      }
    },
  ]
};

export default logindexRouter;
